import { render, staticRenderFns } from "./BrandCampaignInstallmentTable.vue?vue&type=template&id=0d0da70e&scoped=true&"
import script from "./BrandCampaignInstallmentTable.vue?vue&type=script&lang=js&"
export * from "./BrandCampaignInstallmentTable.vue?vue&type=script&lang=js&"
import style0 from "./BrandCampaignInstallmentTable.vue?vue&type=style&index=0&id=0d0da70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0da70e",
  null
  
)

export default component.exports